import { render, staticRenderFns } from "./ProductTicket.vue?vue&type=template&id=710c2270&scoped=true&"
import script from "./ProductTicket.vue?vue&type=script&lang=js&"
export * from "./ProductTicket.vue?vue&type=script&lang=js&"
import style0 from "./ProductTicket.vue?vue&type=style&index=0&id=710c2270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c2270",
  null
  
)

export default component.exports